"use client";
import SectionsSidebar from '@/app/components/sections/SectionsSidebar';

export default function SectionsLayout({ children }) {
  return (
    <div className="container-fluid py-4 px-0">
      <div className="container">
        <div className="row">
        
          
          {/* المحتوى الرئيسي على اليمين */}
          <div className="col-12 mx-auto">
            {children}
          </div>
            {/* Sidebar على اليسار */}
            {/* <SectionsSidebar /> */}
        </div>
      </div>
    </div>
  );
}
